/*
 * Black November: Fortschritt, Erreicht-Zustand und Text der Geschenkstufen.
 *
 * Zwei Dinge kann das Theme von Haus aus nicht:
 *
 * 1. updateProgress() in theme.dev.js kennt nur Versand + eine Geschenkstufe.
 *    Der Abschnitt der dritten Stufe bliebe dauerhaft leer.
 * 2. Die Textzeile ueber dem Balken springt ab Stufe 2 auf
 *    "Du erhaeltst ein Geschenk!" und zeigt nie an, wieviel noch bis zur
 *    dritten Stufe fehlt.
 *
 * Deshalb uebernimmt dieses Skript im Dreistufen-Fall beides komplett.
 * free-shipping.liquid blendet dafuer .free-shipping__success-message aus,
 * damit das Theme nicht dagegenschreibt, und haelt die Startwerte schon
 * serverseitig richtig.
 */
(function () {
  if (window.__bnGiftTiers) return;
  window.__bnGiftTiers = true;

  var timers = [];

  function setValue(el, value) {
    if (!el) return;
    el.value = value;
    el.setAttribute('value', Math.round(value));
  }

  /* Fuellstand eines Abschnitts zwischen zwei Schwellen, in Prozent. */
  function anteil(subtotal, von, bis) {
    if (!(bis > von)) return 0;
    if (subtotal <= von) return 0;
    return Math.min(((subtotal - von) / (bis - von)) * 100, 100);
  }

  function markiere(marker, erreicht) {
    if (!marker) return;
    marker.classList.toggle('is-reached', erreicht);
  }

  /* Betrag in Cent als Text, moeglichst im Format des Shops. */
  function geld(cents) {
    try {
      if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyFormat) {
        return window.theme.formatMoney(cents, window.theme.moneyFormat).replace('.00', '').replace(',00', '');
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  /*
   * Textzeile je nach erreichter Stufe. Die vier Vorlagen haengen als
   * data-bn-message-1..4 am Block, gesetzt von free-shipping.liquid.
   */
  function nachricht(el, subtotal, l1, l2, l3) {
    var ziel = el.querySelector('.free-shipping__default-message');
    if (!ziel) return;

    var vorlage;
    var rest;

    if (subtotal < l1) {
      vorlage = el.getAttribute('data-bn-message-1');
      rest = l1 - subtotal;
    } else if (subtotal < l2) {
      vorlage = el.getAttribute('data-bn-message-2');
      rest = l2 - subtotal;
    } else if (subtotal < l3) {
      vorlage = el.getAttribute('data-bn-message-3');
      rest = l3 - subtotal;
    } else {
      vorlage = el.getAttribute('data-bn-message-4');
      rest = null;
    }

    if (!vorlage) return;
    ziel.textContent = rest === null ? vorlage : vorlage.replace('||amount||', geld(rest));
  }

  function apply(cart) {
    var subtotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var holders = document.querySelectorAll('.free-shipping[data-gift2-limit]');

    for (var i = 0; i < holders.length; i++) {
      var el = holders[i];
      var l1 = parseFloat(el.getAttribute('data-free-shipping-limit')) * 100;
      var l2 = parseFloat(el.getAttribute('data-free-gift-limit')) * 100;
      var l3 = parseFloat(el.getAttribute('data-gift2-limit')) * 100;

      if (!(l3 > l2 && l2 > l1 && l1 > 0)) continue;

      setValue(el.querySelector('[data-gift-bar]'), anteil(subtotal, l1, l2));
      setValue(el.querySelector('[data-gift2-bar]'), anteil(subtotal, l2, l3));
      setValue(el.querySelector('[data-gift2-end]'), subtotal >= l3 ? 100 : 0);

      markiere(el.querySelector('[data-shipping-icon]'), subtotal >= l1);
      markiere(el.querySelector('[data-gift-icon]'), subtotal >= l2);
      markiere(el.querySelector('[data-gift2-icon]'), subtotal >= l3);

      nachricht(el, subtotal, l1, l2, l3);
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(apply)
      .catch(function () {});
  }

  /*
   * Das Theme animiert seine eigenen Balken mit Verzoegerungen von bis zu 2.5s
   * und setzt dabei auch das Endstueck. Deshalb mehrfach nachziehen.
   */
  function schedule() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
    var delays = [0, 400, 1200, 2600, 3200];
    for (var j = 0; j < delays.length; j++) {
      timers.push(setTimeout(refresh, delays[j]));
    }
  }

  var events = [
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart:refresh',
    'theme:product:added',
    'theme:cart-drawer:open'
  ];

  for (var k = 0; k < events.length; k++) {
    document.addEventListener(events[k], schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
